import {
  AlignLeft,
  CheckSquare,
  ChevronDown,
  HelpCircle,
  List,
  Mail,
  ShieldAlert,
  SlidersHorizontal,
  Type
} from "lucide-react";
import { ScopingQuestionType } from "./scoping-schema";

export const FIELD_TYPE_OPTIONS: { value: ScopingQuestionType; label: string }[] = [
  { value: "short_text", label: "Short answer" },
  { value: "email", label: "Email" },
  { value: "long_text", label: "Paragraph" },
  { value: "single_choice", label: "Single choice" },
  { value: "multi_choice", label: "Multiple choice" },
  { value: "dropdown", label: "Dropdown menu" },
  { value: "yes_no", label: "Yes / no" },
  { value: "target_builder", label: "Target builder" }
];

export function questionTypeIcon(type: string, className = "text-ctb-blue") {
  const size = 14;
  const iconCls = className;
  switch (type) {
    case "short_text":
      return <Type size={size} className={iconCls} />;
    case "long_text":
      return <AlignLeft size={size} className={iconCls} />;
    case "email":
      return <Mail size={size} className={iconCls} />;
    case "single_choice":
      return <CheckSquare size={size} className="text-ctb-blue-600" />;
    case "multi_choice":
      return <List size={size} className="text-ctb-blue-600" />;
    case "dropdown":
      return <ChevronDown size={size} className="text-ctb-blue-600" />;
    case "yes_no":
      return <SlidersHorizontal size={size} className={iconCls} />;
    case "target_builder":
      return <ShieldAlert size={size} className="text-rose-500" />;
    default:
      return <HelpCircle size={size} className="text-slate-400" />;
  }
}

export function questionTypeLabel(type: string): string {
  return FIELD_TYPE_OPTIONS.find((o) => o.value === type)?.label ?? type;
}

export function isChoiceType(type: string): boolean {
  return type === "single_choice" || type === "multi_choice" || type === "dropdown";
}
